import * as React from 'react';
import { Dropdown as BSDropdown } from 'react-bootstrap';
import Checkbox from './checkbox';

import * as styling from './checkbox.module.scss';

import '../../styles/bs-prefix.scss';

import { DownArrow } from '../../assets/svg';

type LabelDisplayType = 'dontShowSelected' | 'showSelectedWithLabel' | 'showSelectedInLabel';
export interface Props {
    onSelect?: (e: React.SyntheticEvent<unknown, Event>) => void;
    selected?: string | null;
    label: string;
    menuItems: {
        id?: string; // Only use if friendly name and api name is different. e.target.id defaults to using label
        label: string;
        onClick?: (e: React.SyntheticEvent<HTMLDivElement>) => void;
        disabled?: boolean;
        isSelected?: boolean;
        hasCheckbox?: boolean;
    }[];
    usingMouse: boolean;
    styles?: {
        labelFontClass?: string; // Classnames from globalStyles i.e. 'body3'
        buttonPrefix?: string;
        menuPrefix?: string;
    };
    labelDisplay?: LabelDisplayType;
    hasCheckbox?: boolean;
}

const Select = (props: Props) => {
    const {
        onSelect = () => {
            /* DO NOTHING */
        },
        selected,
        label,
        menuItems,
        styles,
        labelDisplay = 'showSelectedWithLabel',
        hasCheckbox,
        usingMouse
    } = props;
    return (
        <React.Fragment>
            <BSDropdown onSelect={(eventKey, e) => onSelect(e)}>
                <BSDropdown.Toggle
                    className={props.usingMouse ? 'using-mouse' : ''}
                    id='dropdown-basic'
                    bsPrefix={
                        styles && styles.buttonPrefix
                            ? styles.buttonPrefix
                            : 'default-curaleaf-toggle'
                    }>
                    <span
                        className={
                            styles && styles.labelFontClass ? styles.labelFontClass : 'body2'
                        }>
                        {renderLabel(labelDisplay, label, selected)}
                    </span>
                    <DownArrow />
                </BSDropdown.Toggle>
                <div className={menuItems.length > 4 ? 'default-curaleaf-scroll' : ''}>
                    {hasCheckbox
                        ? menuItems.map((item, i) => {
                            if (hasCheckbox && item.hasCheckbox) {
                                return (
                                    <div className={styling.selectbox}>
                                        <Checkbox
                                            key={i}
                                            label={`${item.label}`}
                                            usingMouse={usingMouse}
                                            onClick={item.onClick}
                                            isSelected={item.isSelected ? item.isSelected : false}
                                          />
                                    </div>
                                );
                            }
                            return (
                                <BSDropdown.Item
                                    onClick={e => {
                                        item.onClick ? item.onClick(e) : null;
                                    }}
                                    key={i}
                                    id={item.id ? item.id : item.label}
                                    aria-selected={selected === item.label}
                                    disabled={!!item.disabled}
                                    active={item.isSelected || item.label === selected}
                                    className={props.usingMouse ? 'using-mouse body2' : 'body2'}>
                                    {item.label}
                                </BSDropdown.Item>
                            );
                        })
                        : null}
                </div>
                <BSDropdown.Menu
                    bsPrefix={
                        props.styles && props.styles.menuPrefix
                            ? props.styles.menuPrefix
                            : 'default-curaleaf-dropdown-menu'
                    }>
                    <div className={menuItems.length > 4 ? 'default-curaleaf-scroll' : ''}>
                        {menuItems.map((item, i) => {
                            item.id ? item.id : `${i}`;
                            if (item.onClick) {
                                return (
                                    <BSDropdown.Item
                                        onClick={(e: React.MouseEvent<HTMLDivElement>) => {
                                            item.onClick ? item.onClick(e) : null;
                                        }}
                                        key={i}
                                        id={item.id ? item.id : item.label}
                                        aria-selected={selected === item.label}
                                        disabled={!!item.disabled}
                                        active={item.isSelected || item.label === selected}
                                        className={
                                            props.usingMouse ? 'using-mouse body2' : 'body2'
                                        }>
                                        {item.label}
                                    </BSDropdown.Item>
                                );
                            }
                            return (
                                <BSDropdown.Item
                                    key={i}
                                    aria-selected={selected === item.label}
                                    id={item.id ? item.id : item.label}
                                    active={item.isSelected || item.label === selected}
                                    disabled={!!item.disabled}
                                    className={props.usingMouse ? 'using-mouse body2' : 'body2'}>
                                    {item.label}
                                </BSDropdown.Item>
                            );
                        })}
                    </div>
                </BSDropdown.Menu>
            </BSDropdown>
        </React.Fragment>
    );
};

const renderLabel = (option: LabelDisplayType, label: string, selected: string | null) => {
    switch (option) {
        case 'dontShowSelected': {
            return label;
        }
        case 'showSelectedInLabel': {
            if (selected) {
                return selected;
            }
            return label;
        }
        default: {
            if (selected) {
                return `${label}: ${selected}`;
            }
            return label;
        }
    }
};

export default Select;
